var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "comp_x5F_316-squarespace"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "    M193.22,334.467c-8.669,8.67-8.669,22.721,0,31.389c8.67,8.67,22.721,8.67,31.392,0l141.212-141.212    c17.332-17.331,45.435-17.331,62.764,0c17.331,17.331,17.331,45.433,0,62.765l-138.491,138.48    c17.312,17.332,45.398,17.35,62.728,0.039l0.036-0.039l107.137-107.127c34.67-34.67,34.67-90.867,0-125.527    c-34.671-34.671-90.875-34.671-125.528,0L193.22,334.467L193.22,334.467z M412.91,240.312c-8.67-8.669-22.721-8.669-31.383,0    l-141.23,141.214c-17.312,17.332-45.396,17.35-62.727,0.043l-0.046-0.043c-8.66-8.662-22.702-8.67-31.372-0.008l-0.009,0.008    c-8.67,8.662-8.679,22.711-0.019,31.381l0.019,0.018c34.661,34.654,90.867,34.654,125.525,0L412.9,271.693    C421.57,263.025,421.57,248.973,412.91,240.312L412.91,240.312z M177.534,318.771l141.212-141.215    c8.662-8.669,8.662-22.721,0-31.39c-8.66-8.662-22.704-8.662-31.363,0l-141.24,141.214c-17.322,17.33-45.424,17.34-62.755,0.008    l-0.009-0.008c-17.33-17.322-17.349-45.407-0.027-62.746l0.027-0.027l138.51-138.509c-17.321-17.331-45.415-17.34-62.755-0.019    l-0.018,0.019L51.998,193.234c-34.662,34.669-34.662,90.865,0,125.527C86.676,353.434,142.855,353.434,177.534,318.771z     M99.075,271.693c8.661,8.662,22.703,8.662,31.364,0l141.239-141.222c17.321-17.331,45.416-17.34,62.746-0.02l0.018,0.02    c8.671,8.669,22.721,8.669,31.382,0c8.67-8.67,8.67-22.721,0-31.383c-34.669-34.67-90.857-34.67-125.526,0L99.075,240.312    c-8.67,8.662-8.67,22.714-0.01,31.382H99.075z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon6);
export default __webpack_public_path__ + "static/media/service_icon6.6208b49b1c8fa561a1b581c5aeb03d26.svg";
export { ForwardRef as ReactComponent };